// test856
(856 && 0);
